import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@homeexchange/design';

const StarRatingCompact = ({ nbStars }) => (
    <span className="star-rating-compact">
        <Icon name="StarFill" color="primary" size="xsmall" />
        {nbStars && <span itemProp="ratingValue">{nbStars}</span>}
    </span>
);

StarRatingCompact.propTypes = {
    nbStars: PropTypes.number
};

export default StarRatingCompact;
